import React, {
  forwardRef,
  useState,
  useImperativeHandle,
  useRef,
  useEffect,
} from "react";
import {
  Col,
  Form,
  Row,
  Upload,
  Input,
  DatePicker,
  Select,
  Button,
  notification,
} from "antd";

import { useDispatch, useSelector } from "react-redux";
import {
  chuyenHoaDonThanhPhieuNhap,
  importHoadon,
  setInvoiceNull,
} from "store/slices/sale/nhapxuatSlice";
import SlipModalComponent from "components/SlipModalComponent";
import { SaveOutlined } from "@ant-design/icons";
import KhNccSelect from "views/app-views/common/khachHangNCC";
import moment from "moment";
import ImportInvoiceDetail from "./importInvoiceDetail";
import { DOCUMENT_TYPE_ID } from "constants";
const { Dragger } = Upload;

const UploadFileInvoiceModal = (props, ref) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const childRef = useRef(null);

  const [visibleModal, setVisibleModalImport] = useState(false);
  const [file, setFile] = useState(null);
  const funcRef = useRef({});
  const {
    dmLoaiPhieuNhapXuatList,
    dmDoiTuongList,
    dmKkList,
    dmThuocVatTuList,
  } = useSelector((state) => state.danhMucSale);
  const { DoiTuongList } = useSelector((state) => state.khachhang);
  const { importHoadonList, importHoadonDetailList } = useSelector(
    (state) => state.nhapXuatSale,
  );

  const { dinhKhoanCate } = useSelector((state) => state.dinhKhoanCategory);

  const { profile } = useSelector((state) => state.auth);

  useImperativeHandle(ref, () => ({
    showModal(data, okCallback) {
      funcRef.current.okCallback = okCallback;
      setVisibleModalImport(true);
    },
  }));

  useEffect(() => {
    form.setFieldValue("ngay", moment());
    form.setFieldValue("maloaiphieu", 1);
    form.setFieldValue(
      "mahoadon",
      `${importHoadonList?.hoaDonViewModel?.kiHieuMSHD}${importHoadonList?.hoaDonViewModel?.kiHieuHDon}`,
    );
    form.setFieldValue(
      "sohoadon",
      `${importHoadonList?.hoaDonViewModel?.soHD}`,
    );
    form.setFieldValue(
      "mahoadon",
      `${importHoadonList?.hoaDonViewModel?.maHD}`,
    );
    form.setFieldValue(
      "ngayhoadon",
      moment(importHoadonList?.hoaDonViewModel?.ngayLap),
    );

    const makkgiao = DoiTuongList?.find(
      (f) => f.maSoThue === importHoadonList?.hoaDonViewModel?.mstBan,
    );
    const makknhan = DoiTuongList?.find(
      (f) => f.maSoThue === importHoadonList?.hoaDonViewModel?.mstMua,
    );

    if (makkgiao) form.setFieldValue("makkgiao", makkgiao?.id);
    if (makknhan) form.setFieldValue("makknhan", makknhan?.id);
  }, [DoiTuongList, form, importHoadonList]);

  const onFinish = (values) => {
    const re = importHoadonDetailList?.filter(
      (f) => f.maHangErp === null || f.maHangErp === 0,
    )?.length;
    if (re > 0) {
      notification.error({
        message: "Thông báo",
        description: "Bạn vui lòng Mapping hết các mặt hàng từ Hóa đơn với ERP",
      });
      return;
    }

    const payload = {
      sophieu: values.sophieu,
      makk: values.makk,
      makkgiao: values.makkgiao,
      makknhan: DoiTuongList?.find((f) => f.chiNhanhId === values.chinhanhid)
        ?.id,
      maloaiphieu: values.maloaiphieu,
      madoituong: values.madoituong,
      ngay: values.ngay,
      nguoigiao: values.nguoigiao,
      nguoinhan: values.nguoinhan,
      thue: values.thue || 0,
      mahoadon: values.mahoadon,
      sohoadon: values.sohoadon,
      ngayhoadon: values.ngayhoadon,
      loai: 1,
      daduyet: values.daduyet,
      manvduyet: values.manvduyet,
      manv: values.manv,
      cachtinhthue: values.cachtinhthue,
      ghichu: values.ghichu,
      luanchuyen: false,
      chinhanhid: values.chinhanhid,
      invoiceid: importHoadonList?.hoaDonViewModel?.id,
      tknoid: dinhKhoanCate?.find((f) => f.soTaiKhoan === "156")?.id,
      tkcoid: dinhKhoanCate?.find((f) => f.soTaiKhoan === "331")?.id,
      isthue: props.isThue,
      onSuccess: ({ data }) => {
        // Refresh data after add/update table

        props.reloadData();

        if (Array.isArray(data.data) && childRef.current) {
          for (const item of data.data) {
            if (item.Id && item.MaPhieu) {
              childRef.current.signedDocumentCreate(item.Id, item.MaPhieu);
            }
          }
        }

        notification.info({
          message: "Thông báo",
          description: "Thêm phiếu thành công!",
        });

        setVisibleModalImport(false);
        props.setVisibleModal(true);
        props.setNhapKhoId(data.data[0]?.MaNX);
        dispatch(setInvoiceNull());
      },
    };

    dispatch(chuyenHoaDonThanhPhieuNhap(payload));
  };

  const renderInfo = () => {
    return (
      <>
        <Dragger
          name="importFile"
          multiple={false}
          maxCount={1}
          beforeUpload={() => false}
          showUploadList={false}
          accept={".xlsx"}
          style={{
            backgroundColor: "#f6f6f6",
            borderRadius: 4,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: 50,
          }}
          onChange={(e) => {
            setFile(e.file);
            const formData = new FormData();
            formData.append("importFile", e.file);
            dispatch(
              importHoadon({
                formData,
                onSuccess: (data) => {
                  console.log("data", data);
                },
              }),
            );
          }}
        >
          {file && (
            <p className="ant-upload-hint">
              {file.name} ({(file.size / 1000).toFixed(1)}kb)
            </p>
          )}
          <p className="ant-upload-text">
            Bấm hoặc kéo file vào đây để tải lên
          </p>
          <p className="ant-upload-hint">
            Chấp nhận file .xml có dung lượng tối đa 5MB.
          </p>
        </Dragger>
        <div className="p-3">
          <Row gutter={16}>
            <Col sm={7} md={7} lg={7}>
              <h5>Khách hàng bán:</h5>
            </Col>
            <Col sm={17} md={17} lg={17}>
              <span>{`[${importHoadonList?.hoaDonViewModel?.mstBan}] - ${importHoadonList?.hoaDonViewModel?.tenKHBan}`}</span>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col sm={4} md={4} lg={4}>
              <h5>Địa chỉ:</h5>
            </Col>
            <Col sm={20} md={20} lg={20}>
              <span>{importHoadonList?.hoaDonViewModel?.diaChiBan}</span>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col sm={7} md={7} lg={7}>
              <h5>Khách hàng mua:</h5>
            </Col>
            <Col sm={17} md={17} lg={17}>
              <span>{`[${importHoadonList?.hoaDonViewModel?.mstMua}] - ${importHoadonList?.hoaDonViewModel?.tenKHMua}`}</span>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col sm={4} md={4} lg={4}>
              <h5>Địa chỉ:</h5>
            </Col>
            <Col sm={20} md={20} lg={20}>
              <span>{importHoadonList?.hoaDonViewModel?.diaChiMua}</span>
            </Col>
          </Row>
        </div>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          className="p-3"
          // initialValues={{
          //     ngay: moment(),
          // }}
        >
          <Row gutter={16}>
            <Col sm={8} md={8} lg={7}>
              <Form.Item name="sophieu" label="Số phiếu">
                <Input placeholder="Tự động" readOnly />
              </Form.Item>
            </Col>
            <Col sm={8} md={8} lg={9}>
              <Form.Item
                name="ngay"
                label="Ngày nhập"
                rules={[
                  {
                    required: true,
                    message: "Ngày lập phiếu là bắt buộc",
                  },
                ]}
              >
                <DatePicker
                  showTime
                  style={{ width: "100%" }}
                  placeholder={"Ngày nhập"}
                  format="DD/MM/YYYY HH:mm"
                />
              </Form.Item>
            </Col>
            <Col sm={8} md={8} lg={8}>
              <Form.Item
                name="maloaiphieu"
                label="Loại phiếu"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn loại phiếu",
                  },
                ]}
              >
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={dmLoaiPhieuNhapXuatList?.filter(
                    (x) => x.maloai === 1,
                  )}
                  placeholder="Chọn loại phiếu"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col sm={24} md={24} lg={24}>
              <Form.Item
                name="chinhanhid"
                label="Đơn vị"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn đơn vị",
                  },
                ]}
              >
                <Select
                  placeholder="Đơn vị"
                  allowClear
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={profile?.branchInfos
                    .filter((f) => props.ListDonViXuatHDDT.includes(f.branchId))
                    .map((m) => ({
                      value: m.branchId,
                      label: m.branchName,
                    }))}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col sm={16} md={16} lg={24}>
              <Form.Item
                name="makkgiao"
                label="Đơn vị giao"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn đơn vị giao",
                  },
                ]}
              >
                <KhNccSelect placeholder="Chọn đơn vị giao" />
              </Form.Item>
            </Col>
          </Row>

          {/*
          <Row gutter={16}>
            <Col sm={16} md={16} lg={24}>
              <Form.Item
                name="makknhan"
                label="Đơn vị nhận"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn đơn vị nhận",
                  },
                ]}
              >
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={DoiTuongList.filter((f) => f.loaiDoiTuong !== 3).map(
                    (m) => ({
                      value: m.id,
                      label: m.tenDoiTuong,
                    }),
                  )}
                  placeholder="Chọn đơn vị nhận"
                />
              </Form.Item>
            </Col>
          </Row>
*/}
          <Row gutter={16}>
            <Col sm={12} md={12} lg={12}>
              <Form.Item name="madoituong" label="Đối tượng">
                <Select
                  showSearch
                  allowClear
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={dmDoiTuongList}
                  placeholder="Chọn đối tượng"
                />
              </Form.Item>
            </Col>
            <Col sm={12} md={12} lg={12}>
              <Form.Item name="ngayhoadon" label="Ngày hóa đơn">
                <DatePicker
                  style={{ width: "100%" }}
                  placeholder={"Ngày hóa đơn"}
                  format="DD/MM/YYYY"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col sm={12} md={12} lg={12}>
              <Form.Item name="mahoadon" label="Mã hóa đơn">
                <Input placeholder="Mã hóa đơn" />
              </Form.Item>
            </Col>
            <Col sm={12} md={12} lg={12}>
              <Form.Item name="sohoadon" label="Số hóa đơn">
                <Input placeholder="Số hóa đơn" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col sm={24}>
              <Button
                type="primary"
                onClick={() => {
                  form.submit();
                }}
                icon={<SaveOutlined type="primary" />}
              >
                Lưu & Chuyển thành phiếu nhập kho
              </Button>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col sm={24} md={24} lg={0}>
              <Form.Item name="daduyet" label="Đã duyệt" hidden>
                <Input></Input>
              </Form.Item>
            </Col>
            <Col sm={24} md={24} lg={0}>
              <Form.Item name="manvduyet" label="Mã nhân viên duyệt" hidden>
                <Input></Input>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </>
    );
  };

  return (
    <SlipModalComponent
      ref={childRef}
      maskClosable={false}
      bodyStyle={{ overflowY: "auto", maxHeight: "calc(100vh - 300px)" }}
      width={1400}
      title={"Import hóa đơn"}
      widthInfo={550}
      objectId={importHoadonList?.hoaDonViewModel?.id}
      objectType={"PhieuNhapKho"}
      documentTypeId={DOCUMENT_TYPE_ID.NhapHang}
      titleTLink="Import hóa đơn"
      isVisibleModal={visibleModal}
      onRenderTab={[
        {
          label: "Thông tin chi tiết",
          children: (
            <ImportInvoiceDetail
              invoice_id={importHoadonList?.hoaDonViewModel?.id}
              chiTietList={importHoadonList?.chiTiet}
              dmThuocVatTuList={dmThuocVatTuList}
            />
          ),
        },
      ]}
      onRenderInfo={() => renderInfo()}
      onCancelModal={() => {
        setVisibleModalImport(false);
        form.resetFields();
        dispatch(setInvoiceNull());
      }}
    />
  );
};

export default forwardRef(UploadFileInvoiceModal);
